import formatDate from '../../helpers/format-date';
import IconArrowRight from '../icons/arrow-right';
import {
  BaseellaStatusTitle,
  LogStatusEnum,
} from '../transactions-sidepanels/types';
import IconSelected from '../icons/selected';
import IconSandWatch from '../icons/sand-watch';
import IconClose from '../icons/close';
import { TransactionStatusLogsTypes } from './types';

import styles from './transaction-status-logs.module.css';

const getLogText = (logText?: string) => {
  let log = '-';

  if (logText) {
    log = logText;

    const charIndex = logText.indexOf('{');

    if (charIndex && charIndex > 0) {
      const logName = logText.slice(0, charIndex);

      const logError = logText.slice(charIndex);

      log = `${logName} ${JSON.stringify(JSON.parse(logError), null, 2)}`;
    }
  }

  return log;
};

const getCommentText = (commentText?: string) => {
  let text = commentText;

  if (text?.includes('_')) {
    // text = text.replaceAll('_', ' ');
    text = text
      .split(' ')
      ?.map((item) => {
        let result = item;

        // @ts-ignore
        if (result.includes('_') && BaseellaStatusTitle[result]) {
          // @ts-ignore

          result = BaseellaStatusTitle[result];
        }

        return result;
      })
      .join(' ');
  }

  return text;
};

export default function TransactionStatusLogs({
  logs,
}: TransactionStatusLogsTypes): React.JSX.Element {
  let content;

  if (logs?.length) {
    content = (
      <>
        <div className={styles.title}>Status change log</div>
        <>
          {logs.map((item) => {
            let statusContent;

            if (item.status === LogStatusEnum.SUCCESS) {
              statusContent = (
                <div
                  className={`${styles.statusValue} ${styles.statusValueSuccess}`}
                >
                  <IconSelected />
                  <div className={styles.statusValueText}>
                    Status successfully updated
                  </div>
                </div>
              );
            } else if (
              item.status === LogStatusEnum.QUEUED ||
              item.status === LogStatusEnum.PROCESSING
            ) {
              statusContent = (
                <div
                  className={`${styles.statusValue} ${styles.statusValueQueued}`}
                >
                  <span>
                    {item.status === LogStatusEnum.PROCESSING
                      ? 'Processing'
                      : 'Queued'}
                    <IconSandWatch width={13} height={13} />
                  </span>

                  <div className={styles.statusValueText}>
                    Status update in progress
                  </div>
                </div>
              );
            } else if (item.status === LogStatusEnum.FAIL) {
              statusContent = (
                <div
                  className={`${styles.statusValue} ${styles.statusValueFail}`}
                >
                  <div className={styles.failIcon}>
                    <IconClose width={13} height={13} />
                  </div>
                  <div className={styles.statusValueText}>
                    Update error - status not updated
                  </div>
                </div>
              );
            }

            return (
              <div className={styles.log} key={item.id}>
                <div className={styles.logTop}>
                  <div className={styles.statusWrapper}>
                    {item.txBaseellaStatusFrom && (
                      <>
                        <span>
                          {BaseellaStatusTitle[item.txBaseellaStatusFrom]}
                        </span>
                        <IconArrowRight
                          className={`icon-small ${styles.icon}`}
                        />
                      </>
                    )}
                    {item.txBaseellaStatusTo && (
                      <span>
                        {BaseellaStatusTitle[item.txBaseellaStatusTo]}
                      </span>
                    )}
                    {!item.txBaseellaStatusFrom && !item.txBaseellaStatusTo && (
                      <span>Status hasn&apos;t changed</span>
                    )}
                  </div>
                  <div className={styles.infoWrapper}>
                    <div className={styles.date}>
                      {item?.updatedAt &&
                        item.status !== LogStatusEnum.QUEUED &&
                        item.status !== LogStatusEnum.PROCESSING && (
                          <span>{formatDate(item.updatedAt, true)}</span>
                        )}
                      {statusContent}
                    </div>
                  </div>
                </div>
                <div className={styles.createdDate}>
                  <span>{formatDate(item.createdAt, true)}</span>
                  <span>
                    {(item.creatorUserId &&
                      item?.creatorUser &&
                      item?.creatorUser?.profile &&
                      `${item?.creatorUser?.profile?.firstName} ${item?.creatorUser?.profile?.lastName}`) ||
                      getLogText(item.creatorName)}
                  </span>
                </div>
                {item.creatorComment && (
                  <div className={styles.commentWrapper}>
                    <div className={styles.comment}>
                      {getCommentText(item.creatorComment)}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </>
      </>
    );
  } else {
    content = <div className={styles.empty}>Data not found</div>;
  }
  return content;
}
